const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/ReportPage/ReportList.tsx';
import * as React from 'react';
import moment from 'moment/moment';
import { KISIM_TIME_FORMAT } from '@cistec/common_web/defs/generalDefs';
import { ReportListRow } from './ReportListRow';
import { theme } from 'App/utils/clientSetupManager';
import { css } from '@emotion/css';
import { Report } from '@cistec/common_web/defs/kisim';
import { addDividers } from '@cistec/common_web/utils/ui';

import type { JSX } from "react";

const yearHeader = css`
    height: ${theme.spacing(5)};
    padding: ${theme.spacing(2.5)} ${theme.spacing(1)} ${theme.spacing(0.5)} ${theme.spacing(1)};
    color: #757575;
`;

const dividerCSS = css`
    background-color: #e2e2e2;
`;

interface IProps {
    reports: Report[];
}

export const ReportList = (props: IProps) => {
    const { reports } = props;

    const items: JSX.Element[] = [];
    let currentYear: string;

    reports.forEach(report => {
        const date = moment(report.DAT, KISIM_TIME_FORMAT);
        if (currentYear !== date.format('YYYY') && !date.isSame(moment(), 'year')) {
            currentYear = date.format('YYYY');
            items.push(
                <div className={yearHeader} key={currentYear}>
                    {currentYear}
                </div>
            );
        }
        items.push(<ReportListRow key={`${report.SENDER}_${report.REPORTNR}`} report={report} />);
    });

    return <>{addDividers(items, dividerCSS)}</>;
};
